<div class="repo-contact-org-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="permissionModalLabel">
      <span *ngIf="_contact?.repoContactId === 0">Add New </span>
      <span *ngIf="_contact?.repoContactId > 0">Edit </span>
      <span>Contact </span> <span *ngIf="_contact?.repoContactId > 0"> - {{selectedContactName}}</span>
    </h5>
    <div class="d-flex justify-content-end ms-auto" *ngIf="!isHorseSelectionModel">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="dismissPopup()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="saveContact()"><i class="fa fa-save"></i> Save</button>
    </div>
    <div class="d-flex justify-content-end ms-auto" *ngIf="isHorseSelectionModel">
      <button type="button" class="btn col-auto me-2 btn-secondary"
        (click)="isHorseSelectionModel = false">Cancel</button>
      <button type="button" class="btn col-auto btn-primary" [disabled]="IsDisableAdd()"
        (click)="AddSelectedHorses()">Add Horses</button>
    </div>

  </div>
  <div class="modal-body" *ngIf="!isHorseSelectionModel">
    <div class="ps-4">
      <mat-radio-group [(ngModel)]="formMode" aria-label="Select an option" (change)="onSelectionChange($event)">
        <mat-radio-button value="Existing">Choose Existing Contact</mat-radio-button>
        <div class="row" *ngIf="isShowSearchDropDown" [ngClass]="{'tw-state-disabled': formMode === 'New'}">
          <div class="col-6 pb-1 search-dropdown">
            <app-search-dropdown [(items)]="allContacts" [placeholder]="'Search Contacts...'" [label]=""
              [limit]="10" (selectionChange)="handleSelection($event)">
            </app-search-dropdown>
          </div>
        </div>
        <hr style="margin-left: -24px;" />
        <mat-radio-button value="New">Create New Contact</mat-radio-button>
      </mat-radio-group>
    </div>
    <app-repocontact-edit [(contact)]="_contact" [isUSA]="isUSA" [isShowOrgDropDown]="true"
      [isShowRepoMailCheckboxes]="true"></app-repocontact-edit>
    <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-md mt-3 p-0" #table>
      <table mat-table="matTable" [dataSource]="dataSource" #matTable class="table table-hover" matSort="sort"
        infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="20" [infiniteScrollContainer]="table"
        [fromRoot]="true" (scrolled)="onTableScroll()" [trackBy]="trackByIndex">
        <ng-container matColumnDef="lotNumber">
          <th mat-header-cell class="w-4-rem" *matHeaderCellDef mat-sort-header>
            {{ lotOrHipText }} <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer">
            <div class="hip-td-box text-success">{{ element?.lotNumber }} {{ element?.lotNumberSuffix }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="horseName">
          <th mat-header-cell class="horse-name-heading cursor-pointer w-12-rem" *matHeaderCellDef mat-sort-header>
            <span (click)="sortTableOnHorse('horse')">
              Horse
              <i class="fas fa-sort me-2"></i>
            </span>
            <span (click)="sortTableOnHorse('sire')">
              Sire
              <i class="fas fa-sort me-2"></i>
            </span>
            <span (click)="sortTableOnHorse('dam')">
              Dam <i class="fas fa-sort"></i>
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer">

            <app-horse-label [horse]="element"></app-horse-label>
            <!--<ng-container>
            <span>{{ element?.horseName }}</span>
          </ng-container>
          <span *ngIf="element?.isHorseNamed"
                class="sireAndDam"
                [ngClass]="{
                'text-gray': element?.isHorseNamed
              }">
            <br />
            {{ element?.sire }} x {{ element?.dam }}
          </span>-->
          </td>
        </ng-container>

        <ng-container matColumnDef="horseAgeCategoryName">
          <th mat-header-cell class="horse-age-category-heading cursor-pointer w-6-rem" *matHeaderCellDef
            mat-sort-header>
            Type <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer">
            {{ element.horseAgeCategoryName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="consignor">
          <th mat-header-cell class="consignor-heading cursor-pointer w-7-rem" *matHeaderCellDef mat-sort-header>
            Consignor <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer">
            {{ element.consignor }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell class="action-heading cursor-pointer w-2-rem" *matHeaderCellDef mat-sort-header>
            Action <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer">
            <a href="javascript:void(0)" class="btn btn-outline-primary btn-sm" (click)="DeleteHorse(element)"
              title="Delete Horse">
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns$.value;"
          class="border-start-0 border-end-0 pointer pt-2"></tr>
      </table>
    </div>
    <div class="row mt-2">

      <div class="col-auto">
        <button type="button" class="btn btn-outline-primary" (click)="AddNewHorses()">
          <i class="fa fa-plus me-2"></i>
          Add Horses
        </button>
      </div>
      <div class="col" *ngIf="hasHorseSelectionError">
        <span class="text text-danger">Please add at least one horse to save the contact</span>
      </div>
    </div>
    <div class="row justify-content-center pt-2" *ngIf="contact?.repoContactUID">
      <div class="col-auto text-end">
        <label class="mt-1 mr-1">Analytics Url</label>
      </div>
      <div class="col-6">
        <input type="text" class="form-control" [(ngModel)]="link" #linkInput name="analyticsUrl"
          #analyticsUrl="ngModel" readonly>

      </div>
      <div class="col-auto">
        <button type="button" mat-icon-button class="btn btn-outline-primary btn-sm" (click)="copyLink()">
          Copy
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body" *ngIf="isHorseSelectionModel">
    <div class="row g-2 mb-2  justify-content-start">
      <div class="col-4">
        <label> {{ lotOrHipText }}/Horse </label>
        <input type="text" class="form-control" [placeholder]="autocompletePlacholder" [(ngModel)]="filter"
          (keyup)="filterHorses()" />
      </div>
    </div>
    <div class="table-scroll-section mt-2">
      <table class="table border table-hover">
        <thead class="table-light">
          <tr>
            <th scope="col" class="border-bottom-0">
              <mat-checkbox (change)="masterToggle($event)" [checked]="selectedIdsSet.size > 0 && isAllSelected()"
                [indeterminate]="selectedIdsSet.size > 0 && !isAllSelected()">
              </mat-checkbox>
            </th>
            <th scope="col" class="border-bottom-0">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let horse of saleHorses; let i = index">
            <td>
              <mat-checkbox [(ngModel)]="horse.isSelected" (change)="onCheckboxChange()">
              </mat-checkbox>
            </td>
            <td>
              <span class="ms-2" *ngIf="horse?.lot || horse?.horseName || horse?.dam">
                {{ horse?.lot || "Unknown" }} |
                {{ horse?.horseName || "Unknown" }} |
                {{ horse?.dam || "Unknown" }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
